<h1 class="text-3xl ps-4">
    {{ 'DASHBOARD.PROJECTS' | translate }}
</h1>

<div class="p-4 w-full flex flex-row justify-center gap-4">
    <input type="search" class="w-full text-center h-12 bg-gray-100 max-w-2xl rounded-md overflow-hidden" [(ngModel)]="searchTerm">
</div>
<div class="w-full m-auto">
    <table class=" text-left capitalize max-w-screen-2xl w-full m-auto">
        <thead class="bg-gray-50">
            @if (employeeAuthority()){
                <th scope="col" class="px-4 py-4 hidden xl:block">{{ "GLOBAL.USER" | translate }}</th>
            }
            <th scope="col" class="px-4 py-4">{{ "GLOBAL.PROJECT" | translate }}</th>
            <th scope="col" class="px-6 py-4 hidden 2xl:table-cell">{{ "GLOBAL.CREATED_AT" | translate }}</th>
            <th scope="col" class="px-6 py-4 hidden 2xl:table-cell">{{ "GLOBAL.MODIFIED_AT" | translate }}</th>
            <th scope="col" class="px-4 py-4">{{"DASHBOARD.PROJECT_LISTING.MOST_RECENT_PROJECT_RECORD" | translate}}</th>
            <th scope="col" class="px-4 py-4">{{"GLOBAL.ACTIONS" | translate}}</th>
        </thead>
        <tbody class="divide-y divide-gray-100 border-t border-gray-100">
            @if (!projectResource.hasValue()){
                <tr>
                    <td colspan="6" class="px-6 py-4 text-center">
                        <app-loader-element/>
                    </td>
                </tr>
            } @else {
                @for(project of filteredProjects(); track project.id){
                    <tr class="hover:bg-gray-50">
                        @if (employeeAuthority()) {
                            <td class="px-4 py-4 hidden xl:table-cell">{{project.createdBy}}</td>
                        }
                        <th class="px-4 py-4">
                            <span class="text-lg">{{project.name}}</span>
                            <div class="font-normal text-gray-500 truncate">ID: {{project.id}}</div>
                        </th>
                        <td class="px-6 py-4 hidden 2xl:table-cell">
                            {{project.createdAt | date: "HH:MM - dd/MM/yyyy" }}
                        </td>
                        <td class="px-6 py-4 hidden 2xl:table-cell">
                            {{(project.modifiedAt | date: "HH:MM - dd/MM/yyyy") || (project.createdAt | date: "HH:MM - dd/MM/yyyy") }}
                        </td>
                        <th class="px-4 py-4">
                            <a class="group flex gap-1"  [routerLink]="['/']" [queryParams]="{project: project.id, projectRecord: lastRecord()[$index].id}">
                                <div class="">
                                    <div class="w-fit flex gap-2 self-center">
                                        <label for="move-to-project-{{lastRecord()[$index].id}}" class="self-center">{{"DASHBOARD.TO_PROJECT_RECORD" | translate}}</label>
                                    </div>
                                    <div class="text-sm font-normal text-slate-500">
                                        {{ lastRecordDates()[$index] | date: "HH:mm - dd/MM/yyyy" }}
                                    </div>
                                </div>
                                <img id="move-to-project-{{lastRecord()[$index].id}}" src="assets/images/icons/save.svg" alt="siirry" width="28" height="28" class="animate-infinite group-hover:animate-wiggle-more"/>
                            </a>
                        </th>
                        <th class="px-4 py-4 text-slate-500 text-sm font-normal">
                            <div class="flex items-center gap-4">

                                @if(project.createdBy === user().email){
                                    <button type="button" class="group" (click)="onQuotation(project.name, lastRecord()[$index])">
                                        <img src="assets/images/icons/quote.svg" alt="" width="28" height="28" class="animate-infinite group-hover:animate-wiggle-more mx-auto"/>
                                        <label>{{ "QUOTATION.QUOTATION_REQUEST" | translate }}</label>
                                    </button>
                                }
                                <button type="button" (click)="onDeleteProject(project.id)" class="group">
                                    <svg class="group-hover:animate-wiggle-more mx-auto" width="27" height="29" viewBox="0 0 27 29" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <rect width="27" height="29" fill="url(#pattern0_2016_9917)"/>
                                        <defs>
                                            <pattern id="pattern0_2016_9917" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                <use xlink:href="#image0_2016_9917" transform="matrix(0.01 0 0 0.00875 0 0.0625)"/>
                                            </pattern>
                                            <image id="image0_2016_9917" width="100" height="100" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADaklEQVR4nO3dIYwVVxTG8dOGBEQNbUIxYIpoDa0AAwgQxVBEa4opmzDzfXff2yyEBEIC4mFYSMCAaRO2povoIsCAAQGYVrSmNSAAA6I1RQAJm2y4ZMIKEgwNc+ecM3N+yd9uMt/dEbvJu08khBBCCCGEEMJbABwmefl9an7G2z85/G8ATpLMbQTgTByBkcNgHIq9w2AfD4XkDpLHCnex1GG80cUOnmOH699c9qxmqzgQ6h9EHAj1x48Dof7gcSDUHzkOhPrDxoFQf0w3B8LX/oz4Lhuw+IGEEEIIIYQQghUA5of6xyKAebGG5OKA/0Xyq1hD8pz2MNTrrFgD4JCBYbJSB8Uakt8ZGCZrVNf1t2INgK3aw1CvLWJNVVWfGhgmazQ9Pb1ODPoAwAvtcdhxzTM3zy4WAXigPRC7775YRfL2AN+QW2IVgAXtgdh9v4hVJOcG+IacEqtIjrQHYvdNi1V1XX9jYKDccXvEqpTSlwYGyl1WVdVmsaqqqo+1B2LHjUajtWIZgKfaI7G7nol1AO4ZGCp31F2xjuRNA0PlLgJwQ6wj+fOADmRerBvYZxAnYl1KqRrQG3JArCO5W3sodlRK6WuxrqqqL7SHYnd9LtaNx+OPDAyVu6h5VvGA5BPtsVg4AP+JFyT/1h6M5ftLvABw3cBguXDXxAuSPxkYLJcMwI/iBYAT2oOxfMfFi5TS/gG8IT+IFyR3aQ/GwqWUdooXVVVt0h6M5ftMvJidnV1N8qWB0XKhXk5NTa0RTwD8a2C4XKh/xJuVj3vlPgbgD/GG5FXt4ViuK+INgAsGhsuFOi/ekDxqYLhcIgBHxBsA+7SHY7m+F29SStt7/IZsE29IbtQejoUajUYbxJvJZLKK5LL2eGy/5ebZxCMAjw0MmFvukXhF8ncDA+Y2A/CbeLXy7Ta5Zy2KVz29/+SseNXT+08Oild9vP+ktnivycDvP9kiXo3H4/UGBsxt1tzpIl5NJpMPSS5pj8j2WmqeSTwj+dDAkLmNmrtcxDsAd7SHZHvdFu9IXurRG7Ig3pE8rT0k22tOvAMwNjBkbqmReEdyr4Ehcxs1d7mId3Vdf6U9JFuquctFvJuZmflEe0i2VHOXi/RBcyeI9ph8/55LX/Tk/pO70hcrtztc9hy6+E7CEEIIIYQQQpDuvQKY6gJLRBYRuAAAAABJRU5ErkJggg=="/>
                                        </defs>
                                    </svg>
                                    <div>
                                        {{ "GLOBAL.REMOVE" | translate }}
                                    </div>
                                </button>
                            </div>
                        </th>
                    </tr>
                }
            }


        </tbody>
    </table>
</div>


<!--
<ul class="divide-y border-y divide-gray-200">
    <li class="p-4 hover:bg-gray-50">
        <h4 class="text-lg font-medium leading-loose">Share team inboxes</h4>
        <p class="text-gray-500">Whether you have a team of 2 or 200, our shared team inboxes keep everyone on the same page and in the loop.</p>
    </li>
    <li class="p-4 hover:bg-gray-50">
        <h4 class="text-lg font-medium leading-loose">Deliver instant answers</h4>
        <p class="text-gray-500">An all-in-one customer service platform that helps you balance everything your customers need to be happy.</p>
    </li>
    <li class="p-4 hover:bg-gray-50">
        <h4 class="text-lg font-medium leading-loose">Manage your team with reports</h4>
        <p class="text-gray-500">Measure what matters with Untitled’s easy-to-use reports. You can filter, export, and drilldown on the data in a couple clicks.</p>
    </li>
</ul>
-->